
import type { Result } from '@empathyco/x-types'
import type { PropType } from 'vue'
import type { ExplainMessages } from '../../../models/i18n/explain.messages'
import { defineComponent } from 'vue'
import ExplainResultsTable from '../explain-results-table.component.vue'
import ScoresVisualization from './scores-visualization.component.vue'
import TotalScore from './total-score.component.vue'

export default defineComponent({
  name: 'ProductScoreOverview',
  components: {
    ScoresVisualization,
    TotalScore,
    ExplainResultsTable,
  },
  props: {
    result: {
      type: Object as PropType<Result>,
      required: true,
    },
    query: {
      type: String,
      required: true,
    },
    messages: {
      type: Object as PropType<ExplainMessages>,
      required: true,
    },
  },
  setup() {
    return {
      baseClass: 'epb-product-score-overview',
    }
  },
})
